// Threshold colours for the dashboard compliance bar: 0–25 red, 26–75 orange,
// 76–100 green. Tailwind palette hexes (red-600 / amber-500 / green-600).
export const PROGRESS_RED = '#dc2626';
export const PROGRESS_ORANGE = '#f59e0b';
export const PROGRESS_GREEN = '#16a34a';

export function progressColor(pct: number): string {
  const p = Math.max(0, Math.min(100, pct));
  if (p <= 25) return PROGRESS_RED;
  if (p <= 75) return PROGRESS_ORANGE;
  return PROGRESS_GREEN;
}
